import { render, staticRenderFns } from "./CustomSelectionEdit.vue?vue&type=template&id=449a993e&scoped=true&"
import script from "./CustomSelectionEdit.vue?vue&type=script&lang=js&"
export * from "./CustomSelectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectionEdit.vue?vue&type=style&index=0&id=449a993e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a993e",
  null
  
)

export default component.exports